export default __webpack_public_path__ + "static/media/3.eaa3a888.png";